import {px} from './css';
import {viewport} from './viewport';

(function($, Drupal){

  Drupal.behaviors.mainMenu = {
    attach: function(context, settings) {
      $(once('main-menu', '.main-menu')).each(this.setup.bind(this));
    },

    hideSecondLevelMenu: function(event) {
      const mainMenu = $('.main-menu');
      mainMenu.find('.open').removeClass('open');
      mainMenu.find('.selected').removeClass('selected');
    },

    secondLevelMenu: function(topLevelMenuItem) {
      return $('.second-level-menu[data-parent-menu-item-name="' + $(topLevelMenuItem).data('menu-item-name') + '"]');
    },

    setup: function() {
      this.setupMenuToggle();
      this.setupSecondLevelToggle();
      this.setupMenuLevels();
      this.setupUseAjaxLinks();
    },

    setupUseAjaxLinks: function() {
      $('.menu .use-ajax').on('click', this.toggleMainMenu.bind(this));
    },

    setupMenuLevels: function() {
      $('.second-level-menu-back').on('click', this.hideSecondLevelMenu.bind(this));
      $('.top-level-menu-item').each(function(index, menuItem) {
        const secondLevelMenu = this.secondLevelMenu(menuItem);
        const secondLevelMenuItems = secondLevelMenu.find('.second-level-menu-item');
        if (viewport.width > 640) {
          $(menuItem).on('mouseenter', this.showSecondLevelMenu.bind(this));
        } else {
          if (secondLevelMenuItems.length > 0) {
            $(menuItem).on('click', this.showSecondLevelMenu.bind(this));
          }
        }
      }.bind(this));
    },

    showSecondLevelMenu: function(event) {
      $('.second-level-area').addClass('open');
      const menuItem = $(event.target).closest('.top-level-menu-item');
      $('.top-level-menu-item').removeClass('selected');
      menuItem.addClass('selected');
      $('.second-level-menu').removeClass('open');
      const selectedSecondLevelMenu = this.secondLevelMenu(menuItem);
      selectedSecondLevelMenu.addClass('open');
      const topLevelArea = menuItem.parents('.top-level-area');
      topLevelArea.addClass('open');
    },

    toggleMainMenu: function() {
      if ($('.main-menu').hasClass('open')) {
        this.closeMainMenu();
      } else {
        this.openMainMenu();
      }
    },

    closeMainMenu: function () {
      const mainMenu = $('.main-menu');
      $('.region-primary-menu').removeClass('open');
      mainMenu.removeClass('open');
      mainMenu.find('.open').removeClass('open');
      mainMenu.find('.selected').removeClass('selected');
    },

    openMainMenu: function () {
      $('.region-primary-menu').addClass('open');
      $('.main-menu').addClass('open');
    },

    setupMenuToggle: function() {
      const mainMenuToggle = $('.main-menu .menu-toggle');
      mainMenuToggle.on('click', this.toggleMainMenu.bind(this));
    },

    setupSecondLevelToggle: function() {
      const secondLevelMenuItems = $('.main-menu .second-level-menu-item');
      const mainMenu = this;
      const locationBase = window.location.pathname;
      secondLevelMenuItems.each(function(index, menuItem) {
        const link = $(menuItem).find('a');
        const href = link.attr('href');
        const hrefBase = new URL(href, window.location.origin).pathname;
        if (locationBase == hrefBase) {
          $(menuItem).on('click', mainMenu.closeMainMenu.bind(this));
        }
      });
    },
  }

})(jQuery, Drupal);
